/*
* NAME: Display
* DESCRIPTION: Wrapper, used for showing/hiding inner content
* */

import React from 'react';
import PropTypes from 'prop-types';

export const Display = ({ children, isShown, display, className = '', style = {} }) =>
  isShown &&
  <div style={{ display: display || 'block', ...style }} className={className}>
    {React.Children.toArray(children)}
  </div>;

Display.propTypes = {
  children: PropTypes.node,
  isShown: PropTypes.bool.isRequired,
  display: PropTypes.string,
  className: PropTypes.string,
};

Display.defaultProps = {
  className: '',
  style: {},
  display: 'block',
};

export default Display;



// WEBPACK FOOTER //
// ./src/components/Display/index.js